import { useState, useEffect, useContext, useRef } from "react";
import MassagePreview from "../../chat/modals/MassagePreview";
import { NavLink, useLocation } from "react-router-dom";
import { CloseIcon, ListIcon, SearchIcon, ExitDoorIcon } from "../Icons";
import Cookies from "js-cookie";
import GetName from "./GetName";
import EnterPhoneNumberChat from "./EnterPhoneNumberChat";
import VerifyCodeChat from "./VerifyCodeChat";
import Select from "react-select";

import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  SendButton,
  MessageSeparator,
} from "@chatscope/chat-ui-kit-react";
import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
import AuthenticationContext from "../../../Authentication/AuthenticationContext";
import { Modal, Button, Form } from "react-bootstrap";
import useAxios from "./service/useAxios";
import { LoopCircleLoading } from "react-loadingg";
import useWindowSize from "../../../hooks/useWindowSize";

import { TimeStampToJalali } from "../../../utils/helperFunction";

export default function ChatWidget({ page = true }) {
  const auth = useContext(AuthenticationContext);
  const { width, height } = useWindowSize();
  const location = useLocation();
  const [heightChat, setHeightChat] = useState(60);
  const [widthChat, setWidthChat] = useState(60);
  const [allMsg, setAllMsg] = useState([]);
  const [text, setText] = useState("");
  const fileData = useRef(null);
  const [spinner, setSpinner] = useState(false);
  const [files, setFiles] = useState([]);
  const [show6, setShow6] = useState(false);
  const [timer, setTimer] = useState("");
  const handleShow6 = () => setShow6(true);
  const [step, setStep] = useState(1);
  const [hashCode, setHashCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [userInfo, setUserInfo] = useState("");
  const [isLogged, setIsLogged] = useState(false);
  const [updater, setUpdater] = useState(false);
  const [supplier, setSupplier] = useState([]);
  const [supplierValue, setSupplierValue] = useState("");
  const [accessChatPage, setAccessChatPage] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);
  // const { userInfo, isLogged } = useContext(AuthenticationContext);
  const handleClick = () => {
    fileData.current.click();
  };

  const { execute: SendMessage } = useAxios("api/chat_send_message");
  const { loading, execute: SendImg } = useAxios("api2/upload_img");
  const { execute: CheckLoginInfoAPI } = useAxios("api/checklogininfo");
  const { execute: find_customers } = useAxios("api2/Find_CustomerUserLink");

  const uploadFile = (file) => {
    if (file.length > 0) {
      setFiles(file);
      handleShow6();
    }
  };

  const uploadImage = async (filesArray) => {
    const promises = [];
    let filesId = [];
    filesArray.map(async (item) => {
      let result = SendImg({ file: item });
      promises.push(result);
    });
    const results = await Promise.all(promises);
    results.map((item) => {
      if (item["status"]) {
        filesId.push(item["result"]["id"]);
      }
    });
    return filesId;
  };

  const sendHandler = (filesArray) => {
    if (text == "") {
      showSwalError("متن خالی است");
      return;
    }
    if (supplierValue == "") {
      showSwalError("ابتدا اکانت خود را انتخاب کنید");
      return;
    }
    setSpinner(true);
    uploadImage(filesArray).then((filesId) => {
      SendMessage({
        sender_id: userInfo["id"],
        is_customer: "1",
        text: text,
        file_id: filesId.toString(),
        is_admin_note: 0,
        customer_id: supplierValue["value"],
      }).then((result) => {
        if (result["status"] == 1) {
          setSpinner(false);
          setShow6(false);
          setText("");
          // showSwalSuccess("ارسال شد");
        } else {
          setSpinner(false);
          setShow6(false);
          setText("");
          showSwalError("لطفا دوباره امتحان کنید");
        }
      });
    });
  };

  const { execute: allMassage } = useAxios("api/get_chat_info");
  const get_msg = async () => {
    setTimer(
      setInterval(async () => {
        let array = [];
        let result = await allMassage({
          is_customer: 1,
          customer_id: supplierValue["value"],
        });
        if (result["status"] == 1) {
          let arrayMsg = result["messages"].map((v) => {
            return {
              ...v,
              day: TimeStampToJalali(parseInt(v.mtm) * 1000, "DD"),
              month: TimeStampToJalali(parseInt(v.mtm) * 1000, "MM"),
              year: TimeStampToJalali(parseInt(v.mtm) * 1000, "YYYY"),
            };
          });
          arrayMsg.sort((s1, s2) => {
            return s1["mtm"] - s2["mtm"];
          });
          arrayMsg.map((element, index) => {
            if (
              index == 0 ||
              element?.day != arrayMsg[index - 1]?.day ||
              element?.year != arrayMsg[index - 1]?.year ||
              element?.month != arrayMsg[index - 1]?.month
            ) {
              array.push(
                <MessageSeparator
                  content={`${element?.year}/${element?.month}/${element?.day}`}
                  as="h2"
                />
              );
            }
            if (element["reciver_id"] == userInfo["id"]) {
              if (element["file_path"] != "" && element["file_path"] != null) {
                array.push(
                  <Message
                    key={`img${index}`}
                    type="image"
                    model={{
                      direction: "incoming",
                      payload: {
                        src: `http://tatdemo.ir/irancovercrmb/${element["file_path"]}`,
                        width: "300px",
                      },
                    }}
                  >
                    {" "}
                    <Message.Footer
                      sentTime={TimeStampToJalali(
                        parseInt(element["mtm"]) * 1000,
                        "HH:MM"
                      )}
                    />
                  </Message>
                );
              }
              if (element["text"] != "") {
                array.push(
                  <Message
                    key={`text${index}`}
                    model={{
                      message: element["text"],
                      // sentTime: "just now",
                      // sender: "me",
                      direction: "incoming",
                      position: "single",
                    }}
                  >
                    {" "}
                    <Message.Footer
                      sentTime={TimeStampToJalali(
                        parseInt(element["mtm"]) * 1000,
                        "HH:MM"
                      )}
                    />
                  </Message>
                );
              }
            } else {
              if (element["file_path"] != "" && element["file_path"] != null) {
                array.push(
                  <Message
                    key={`img${index}`}
                    type="image"
                    model={{
                      direction: "outgoing",
                      payload: {
                        src: `http://tatdemo.ir/irancovercrmb/${element["file_path"]}`,
                        width: "300px",
                      },
                    }}
                  />
                );
              }
              if (element["text"] != "") {
                array.push(
                  <Message
                    key={`text${index}`}
                    model={{
                      message: element["text"],
                      // sentTime: "just now",
                      // sender: "me",
                      direction: "outgoing",
                      position: "single",
                    }}
                  >
                    {" "}
                    <Message.Footer
                      sentTime={TimeStampToJalali(
                        parseInt(element["mtm"]) * 1000,
                        "HH:MM"
                      )}
                    />
                  </Message>
                );
              }
            }
          });
          setLoadingChat(false);
        }
        setAllMsg(array);
      }, 2000)
    );
  };

  const checkCookie = () => {
    if (Cookies.get("token")) {
      CheckLoginInfoAPI().then((value) => {
        setUserInfo({
          token: Cookies.get("token"),
          fullName: value.userinfo.fullname,
          mobile: value.userinfo.mobile,
          id: value.userinfo.id,
        });
        setIsLogged(true);
        if (value.userinfo.fullname == "") setStep(3);
        else setStep(4);
        find_customers({
          tbl_name: "left join,customers,customer_id,id",
          conditions: `user_id/=/${value.userinfo.id}`,
        }).then((data) => {
          let array = [];
          data.map((item) => {
            array.push({
              value: item["customers__id"],
              label:
                item["firstname"] +
                " " +
                item["lastname"] +
                "-" +
                item["company_name"],
            });
          });
          setSupplier(array);
        });
      });
    } else {
      setUserInfo({
        token: "",
        fullName: "",
        mobile: "",
        id: "",
      });
      setIsLogged(false);
    }
  };
  const logout = () => {
    Cookies.remove("token");
    setSupplierValue("");
    setMobile("");
    setAllMsg([]);
    setUserInfo({
      token: "",
      fullName: "",
      mobile: "",
      id: "",
    });
    setIsLogged(false);
    setStep(1);
  };
  useEffect(() => {
    setAccessChatPage(
      auth.userInfo.userRoll.includes(42)
      //42 عدد دسترسی برای صفحه پیام رسان است
    );
  }, [auth.userInfo.userRoll]);
  useEffect(() => {
    if (isLogged && supplierValue != "") {
      clearInterval(timer);
      setFiles([]);
      get_msg();
    }
    if (heightChat != 60) {
      // checkCookie();
    }

    if (page) {
      // checkCookie();
      setHeightChat(600);
      setWidthChat(310);
    }
  }, [step, updater, supplierValue]);
  useEffect(() => {
    checkCookie();
  }, []);
  useEffect(() => {
    if (supplier.length > 0) {
      setSupplierValue(supplier[0]);
      setLoadingChat(true);
    }
  }, [supplier]);
  console.log("object", supplierValue, isLogged, userInfo, step);
  return (
    <>
      {location["pathname"] != "/chat" && (
        <div
          className=""
          style={{
            // top: page && "20px",
            position: page ? "static" : "fixed",
            bottom: "70px",
            right: page ? "0px" : "20px",
            left: "auto",
            width: page ? (width < 600 ? "90%" : "60%") : `${widthChat}px`,
            height:
              widthChat == 60
                ? "10%"
                : height < 500
                ? 400
                : (height * 90) / 100,
            // height: "70%",
            background: widthChat != 60 && "white",
            borderRadius: widthChat == 60 ? "50%" : "10px",
            zIndex: "2",
            display: "flex",
            flexDirection: "column",
            margin: page && "20px auto",
            border: page && "1px solid rgb(0, 188, 212)",
          }}
        >
          <Form.Control
            onChange={(e) => {
              uploadFile(e.target.files);
            }}
            className="d-none"
            ref={fileData}
            type="file"
          />
          {!page && accessChatPage && (
            <NavLink to={"/chat"}>
              {" "}
              <svg
                onClick={() => {
                  // checkCookie();
                  // if (isLogged) {
                  //   get_msg();
                  // }
                  // setUpdater(!updater);
                  // setHeightChat(600);
                  // setWidthChat(310);
                }}
                style={{
                  bottom: "10px",
                  position: "relative",
                  cursor: "pointer",
                  display: widthChat == 60 ? "inline" : "none",
                  background: "red",
                  borderRadius: "50%",
                  marginTop: "auto",
                }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 120 120"
              >
                <path
                  d="M60.19,53.75a3,3,0,1,0,3.06,3A3,3,0,0,0,60.19,53.75Zm-11.37,0a3,3,0,1,0,3.06,3A3,3,0,0,0,48.81,53.75Zm45.94,4A35,35,0,1,0,52.75,92v12.76s14.55-4.25,30.53-19.28C94.68,74.74,94.75,59.41,94.75,59.41l0,0C94.74,58.87,94.75,58.3,94.75,57.72Zm-10.14.6s0,10.64-8,18.09A57.93,57.93,0,0,1,53,89.8V80.34A24.29,24.29,0,1,1,84.61,57.16c0,.4,0,.8,0,1.19ZM70.69,53.75a3,3,0,1,0,3.06,3A3,3,0,0,0,70.69,53.75Z"
                  transform="translate(0.25 0.25)"
                  style={{ fill: "#ffffff" }}
                ></path>
              </svg>
            </NavLink>
            // : (
            //   <>
            //     <svg
            //       onClick={() => {
            //         checkCookie();

            //         if (isLogged && supplierValue != "") {
            //           get_msg();
            //         }
            //         setUpdater(!updater);
            //         setHeightChat(600);
            //         setWidthChat(310);
            //       }}
            //       style={{
            //         bottom: "10px",
            //         position: "relative",
            //         cursor: "pointer",
            //         display: widthChat == 60 ? "inline" : "none",
            //         background: "red",
            //         borderRadius: "50%",
            //         marginTop: "auto",
            //       }}
            //       xmlns="http://www.w3.org/2000/svg"
            //       viewBox="0 0 120 120"
            //     >
            //       <path
            //         d="M60.19,53.75a3,3,0,1,0,3.06,3A3,3,0,0,0,60.19,53.75Zm-11.37,0a3,3,0,1,0,3.06,3A3,3,0,0,0,48.81,53.75Zm45.94,4A35,35,0,1,0,52.75,92v12.76s14.55-4.25,30.53-19.28C94.68,74.74,94.75,59.41,94.75,59.41l0,0C94.74,58.87,94.75,58.3,94.75,57.72Zm-10.14.6s0,10.64-8,18.09A57.93,57.93,0,0,1,53,89.8V80.34A24.29,24.29,0,1,1,84.61,57.16c0,.4,0,.8,0,1.19ZM70.69,53.75a3,3,0,1,0,3.06,3A3,3,0,0,0,70.69,53.75Z"
            //         transform="translate(0.25 0.25)"
            //         style={{ fill: "#ffffff" }}
            //       ></path>
            //     </svg>
            //   </>
            // )
          )}
          <header
            style={{
              background: " rgb(0, 188, 212) ",
              borderTopLeftRadius: page ? "10px" : "10px",
              borderTopRightRadius: page ? "10px" : "10px",
              padding: "10px",
              display: widthChat != 60 ? "block" : "none",
              paddingBottom: !page && step == 4 ? "10px" : "10px",
            }}
          >
            <div class="d-flex justify-content-between">
              <div class="title-name" style={{ color: "white" }}>
                پشتیبانی سایت
              </div>
              <div className="d-flex">
                <button
                  onClick={() => {
                    clearInterval(timer);
                    setHeightChat(60);
                    setWidthChat(60);
                  }}
                >
                  <CloseIcon color="white" />
                </button>
                {isLogged && (
                  <button
                    onClick={() => {
                      logout();
                    }}
                  >
                    {" "}
                    <ExitDoorIcon
                      color="white"
                      style={{ cursor: "pointer", marginRight: 5 }}
                    />
                  </button>
                )}
              </div>
            </div>
            {isLogged && step == 4 && (
              <div>
                <hr className="" />
                <label
                  className="test text-white"
                  style={{ marginBottom: "0.5rem" }}
                >
                  اکانت خود را انتخاب کنید
                </label>
                <Select
                  options={supplier}
                  onChange={(e) => {
                    if (e.value != supplierValue[0]?.value) {
                      setLoadingChat(true);
                    }
                    setSupplierValue(e);
                  }}
                  value={supplierValue}
                />
              </div>
            )}
          </header>

          {isLogged ? (
            userInfo.fullName != "" ? (
              loadingChat ? (
                <div
                  className="w-100 h-100 position-relative"
                  style={{
                    backgroundColor: "rgb(228, 228, 245)",
                    opacity: "0.3",
                    // minHeight: (winSize.height * 80) / 100,
                  }}
                >
                  <div
                    className="position-absolute"
                    style={{
                      // position: "fixed",
                      // left: "0",
                      right: "45%",
                      top: "50%",
                      // bottom: "0",
                      // overflow: "hidden",
                      // backgroundColor: "rgba(209, 225, 240,0.7)",
                      zIndex: 5,
                    }}
                  >
                    <LoopCircleLoading color="rgb(150 150 181)" />
                  </div>
                </div>
              ) : (
                <MainContainer
                  dir="ltr"
                  className="flex-grow-1 pt-2"
                  style={{
                    display: widthChat != 60 ? "block" : "none",
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    // bottom: page ? "0px" : "100px",
                    // height: !page && "30rem",
                    height: "70%",
                  }}
                >
                  <ChatContainer>
                    <MessageList>{allMsg.map((item) => item)}</MessageList>

                    <MessageInput
                      style={{ direction: "rtl" }}
                      value={text}
                      onChange={(e) => {
                        setText(e);
                      }}
                      onAttachClick={handleClick}
                      onSend={(e) => {
                        sendHandler(files);
                      }}
                      placeholder="اینجا تایپ کنید ... "
                    />
                  </ChatContainer>
                </MainContainer>
              )
            ) : (
              step == 3 && (
                <GetName
                  userInfo={userInfo}
                  setStep={setStep}
                  get_mag={() => {
                    if (isLogged && supplierValue != "") {
                      get_msg();
                    }
                  }}
                  style={{
                    display: widthChat != 60 ? "block" : "none",
                  }}
                />
              )
            )
          ) : (
            <div
              className="m-3"
              style={{
                display: widthChat != 60 ? "block" : "none",
              }}
            >
              {step === 1 ? (
                <EnterPhoneNumberChat
                  mobile={mobile}
                  setMobile={(state) => setMobile(state)}
                  setStep={(state) => setStep(state)}
                  setHashCode={(state) => setHashCode(state)}
                />
              ) : (
                <VerifyCodeChat
                  mobile={mobile}
                  hashCode={hashCode}
                  get_mag={() => {
                    if (isLogged && supplierValue != "") get_msg();
                  }}
                  setStep={(state) => setStep(state)}
                  checkCookie={() => checkCookie()}
                />
              )}
            </div>
          )}
        </div>
      )}
      <MassagePreview
        show={show6}
        setShow={setShow6}
        files={files}
        setFiles={setFiles}
        setText={setText}
        text={text}
        // adminMsg={adminMsg}
        // setAdminMsg={setAdminMsg}
        adminMsgFlag={false}
        sendHandler={sendHandler}
        spinnerStatus={spinner}
      />
    </>
  );
}
